import { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { toast } from "react-toastify";
import { getAdminDocumentTypes,getUserCustomSettings, updateCustomSettings } from "../../services/adminDocuments_service";
import useAuthStore from "../../../../store/authStore";
const CustomizeCategoryModal = ({
  show,
  onClose,
  setReapplyFilters
}) => {

  const [availableCategories, setAvailableCategories] = useState([]);
  const [selectedCategoryList, setSelectedCategoryList] = useState([]);
  const [customSettings, setCustomSettings] = useState([]);
  const user = useAuthStore((state)=> state.user);

  const [selectedLeftRow, setSelectedLeftRow] = useState(null);
  const [selectedRightRow, setSelectedRightRow] = useState(null);

  const fetchCategories = async () => {
          try{
              const availableCategoryResponse = await getAdminDocumentTypes();
              const customSettingsResponse = await getUserCustomSettings(user,'AdminDocument','Category');
              const selectedIds = customSettingsResponse.data[0].value.split(",").map(Number);

              const selected = availableCategoryResponse.data.filter(c =>
                selectedIds.includes(c.documentTypeID)
              );

              const remaining = availableCategoryResponse.data.filter(c =>
                !selectedIds.includes(c.documentTypeID)
              );

              setSelectedCategoryList(selected);
              setAvailableCategories(remaining);

              setCustomSettings(customSettingsResponse.data);
              
          }
          catch{
              setSelectedCategoryList([]);
  setAvailableCategories([]);

  setCustomSettings([]);
              
          }
      }


  
  
      useEffect(()=>{
          fetchCategories();
      },[])


  const columnDefs = [
    {
      headerName: "Category",
      field: "documentTypeName",
      flex: 1
    }
  ];

  const handleAdd = () => {

  if (!selectedLeftRow) {
    toast.error("Select a category to add");
    return;
  }

  const exists = selectedCategoryList.some(
    c => c.documentTypeID === selectedLeftRow.documentTypeID
  );

  if (exists) {
    toast.warn("Category already selected");
    return;
  }

  setSelectedCategoryList(prev => [...prev, selectedLeftRow]);

  setAvailableCategories(prev =>
    prev.filter(c => c.documentTypeID !== selectedLeftRow.documentTypeID)
  );

  setSelectedLeftRow(null);

};

  const handleRemove = () => {

  if (!selectedRightRow) {
    toast.error("Select a category to remove");
    return;
  }

  setAvailableCategories(prev => [...prev, selectedRightRow]);

  setSelectedCategoryList(prev =>
    prev.filter(c => c.documentTypeID !== selectedRightRow.documentTypeID)
  );

  setSelectedRightRow(null);

};


  const handleSave = async() => {
    if(selectedCategoryList.length === 0){
      toast.error('Please select atleast one category to save')
      return
    }
    const payload = {
        "settingId": customSettings[0].settingId,
        "pageName": "AdminDocument",
        "valueName": "Category",
        "value": selectedCategoryList.map(item => item.documentTypeID).join(","),
        "param1": selectedCategoryList.map(item => item.documentTypeName).join(","),
        "userId": user
      }
    try{
      
      await updateCustomSettings(payload)
      toast.success('Settings updated')
    }
    catch{
      toast.error('Unable to update settings')
    }
    onClose();
    setReapplyFilters(true);
  };

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>

        <div className="modal-dialog" style={{ width: "60%" }}>

          <div className="modal-content">

            {/* HEADER */}

            <div className="modal-header" style={{ padding: "0px 0px" }}>

              <button
                className="close"
                onClick={onClose}
              >
                &times;
              </button>

              <h4 className="modal-title" style={{ margin: 0 }}>
                Customize Category
              </h4>

            </div>

            {/* BODY */}

            <div className="modal-body">

              <div className="row">

                {/* AVAILABLE */}

                <div className="col-sm-5">

                  <label style={{ fontWeight: "bold" }}>
                    Available Category
                  </label>

                  <div className="ag-theme-alpine" style={{ height: "250px" }}>
                    <AgGridReact
                      theme={"legacy"}
                      rowData={availableCategories}
                      columnDefs={columnDefs}
                      rowSelection="single"
                      onRowClicked={(p) => setSelectedLeftRow(p.data)}
                      onRowDoubleClicked={(params) => {
                        setSelectedLeftRow(params.data);
                        handleAdd();
                        }}
                    />
                  </div>

                </div>

                {/* BUTTONS */}

                <div
                  className="col-sm-2"
                  style={{ textAlign: "center", paddingTop: "90px" }}
                >

                  <button
                    className="btn btn-primary"
                    style={{ width: "90px", marginBottom: "10px" }}
                    onClick={handleAdd}
                  >
                    Add
                  </button>

                  <br />

                  <button
                    className="btn btn-primary"
                    style={{ width: "90px" }}
                    onClick={handleRemove}
                  >
                    Remove
                  </button>

                </div>

                {/* SELECTED */}

                <div className="col-sm-5">

                  <label style={{ fontWeight: "bold" }}>
                    Selected Category
                  </label>

                  <div className="ag-theme-alpine" style={{ height: "250px" }}>
                    <AgGridReact
                      theme={"legacy"}
                      rowData={selectedCategoryList}
                      columnDefs={columnDefs}
                      rowSelection="single"
                      onRowClicked={(p) => setSelectedRightRow(p.data)}
                      onRowDoubleClicked={(params) => {
                        setSelectedRightRow(params.data);
                        handleRemove();
                        }}
                    />
                  </div>

                </div>

              </div>

            </div>

            {/* FOOTER */}

            <div className="modal-footer">

              <button
                className="btn btn-primary"
                onClick={handleSave}
              >
                Save
              </button>

              <button
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>

            </div>

          </div>

        </div>

      </div>
    </>
  );
};

export default CustomizeCategoryModal;